import { AxiosResponse } from 'axios'
import { Index } from '@libs/types/generated/rates-research-api'

const resources = http => ({
  getAll() {
    return http({
      method: 'get',
      url: '/indexes'
    })
  },

  create(data: Partial<Index>) {
    return http({
      method: 'post',
      url: '/indexes',
      data
    })
  },

  edit(data: Partial<Index>) {
    return http({
      method: 'put',
      url: `/indexes/${data.id}`,
      data
    })
  },

  delete(data: Partial<Index>) {
    return http({
      method: 'delete',
      url: `/indexes/${data.id}`
    })
  }
})

export default resources

export interface IndexesHttpModel {
  getAll: () => Promise<AxiosResponse<Index[]>>
  create: (data: Partial<Index>) => Promise<AxiosResponse<Index>>
  edit: (data: Partial<Index>) => Promise<AxiosResponse<Index>>
  delete: (data: Partial<Index>) => Promise<AxiosResponse>
}
